<div class="cart-page" [class.cart-page--mobile]="isMobileView">
  <div *ngIf="cart !== undefined && cart.cartDetails !== undefined && cart.cartDetails.length === 0" class="cart-empty">
    <p class="cart-empty__kicker">Your cart</p>
    <h1 class="cart-empty__title">Nothing in play yet</h1>
    <p class="cart-empty__copy">
      <span class="cart-empty__name" *ngIf="loggedUser">{{ loggedUser.firstName }} {{ loggedUser.lastName }}</span>
      Add webinar seats to start checkout.
    </p>
    <a class="cta cta--gold" routerLink="/Webinar-rooms">Explore rooms</a>
  </div>

  <div *ngIf="isShippingAddressAvailable !== undefined && !isShippingAddressAvailable" class="cart-alert">
    <p>
      Billing and shipping address not found.
      <a routerLink="/MyAccount/2" class="cart-alert__link">Add them in My Account</a>
      to continue checkout.
    </p>
  </div>

  <div *ngIf="IsTransCompleted" class="cart-alert cart-alert--success">
    <h1>Transaction complete</h1>
    <p>Transaction id {{ paymentInfo.transactionId }}</p>
  </div>

  <div class="cart-shell" *ngIf="cartDetails.length > 0 && !IsTransCompleted">
    <header class="cart-head">
      <a
        class="cta cta--ghost"
        role="button"
        tabindex="0"
        *ngIf="currentSurfedWebinarId != null && currentSurfedWebinarId !== 0"
        (click)="goToWebinars()"
        (keyup.enter)="goToWebinars()"
        matTooltip="Back to last viewed webinar">
        ← Back
      </a>
      <div class="cart-head__copy">
        <p class="cart-kicker">Hold your seats</p>
        <h1 class="cart-title">Your cart</h1>
      </div>
      <div class="cart-timer" *ngIf="cartRemainingTime !== '0' && cartRemainingTime !== ''">
        <mat-icon>av_timer</mat-icon>
        <span>Checkout within <strong>{{ cartRemainingTime }}</strong></span>
      </div>
    </header>

    <div class="cart-list">
      <article class="cart-card" *ngFor="let item of cartDetails; let i = index">
        <header class="cart-card__top">
          <span class="cart-card__label">Order for</span>
          <h2 class="cart-card__name">{{ item.productName }}</h2>
          <span class="cart-card__room">{{ item.roomName }}</span>
        </header>

        <div class="cart-card__stats">
          <div class="cart-stat">
            <span>Cost per seat</span>
            <strong class="money">{{ item?.cost | currency }}</strong>
          </div>
          <div class="cart-stat">
            <span>Line total</span>
            <strong class="money">{{ cartWebinarWisetotalCost(item.webinarId) | currency }}</strong>
          </div>
        </div>

        <div class="cart-seats">
          <span class="cart-seats__label">Seat numbers</span>
          <div class="cart-seats__row">
            <button
              type="button"
              mat-mini-fab
              class="seat-chip"
              *ngFor="let seat of item.seats"
              matTooltip="Remove seat no {{ seat.seatNumber }} from this order"
              (click)="deleteCartSeat(seat.seatId, item.webinarId, item.cartId)">
              {{ seat.seatNumber }}
            </button>
          </div>
          <p class="cart-seats__hint" *ngIf="item.seatNumber.length > 0">
            Tap a seat number to drop it from this order.
          </p>
        </div>

        <a
          class="cta cta--danger"
          role="button"
          tabindex="0"
          (click)="deleteWebinarWithAllSeats(item.webinarId, item.cartId)"
          (keyup.enter)="deleteWebinarWithAllSeats(item.webinarId, item.cartId)"
          matTooltip="Remove all seats of this webinar from cart">
          Remove listing
        </a>
      </article>
    </div>

    <footer class="cart-foot">
      <div class="cart-foot__total" *ngIf="!isAllFreeBeeWebinars()">
        <span>Total order amount</span>
        <strong class="money money--total">{{ cartTotalCost() | currency }}</strong>
      </div>
      <div class="cart-foot__total cart-foot__total--free" *ngIf="isAllFreeBeeWebinars()">
        <span>Freebie webinars</span>
        <strong>No payment required</strong>
      </div>

      <a
        class="cta cta--gold"
        role="button"
        tabindex="0"
        *ngIf="!isAllFreeBeeWebinars()"
        [class.is-disabled]="!isShippingAddressAvailable"
        (click)="isShippingAddressAvailable && initiatPayment()"
        (keyup.enter)="isShippingAddressAvailable && initiatPayment()">
        <mat-icon>shopping_cart_checkout</mat-icon>
        Checkout
      </a>
      <a
        class="cta cta--gold"
        role="button"
        tabindex="0"
        *ngIf="isAllFreeBeeWebinars()"
        (click)="purchaseFreeBeeWebinars()"
        (keyup.enter)="purchaseFreeBeeWebinars()">
        <mat-icon>check_circle</mat-icon>
        Purchase free seats
      </a>
    </footer>
  </div>
</div>
